// extracted by mini-css-extract-plugin
module.exports = {"developmentHistory":"DevelopmentHistory_developmentHistory_10L1_","historyTitle":"DevelopmentHistory_historyTitle_n86LZ","historyImgBox":"DevelopmentHistory_historyImgBox_2sPbR"};